export default __webpack_public_path__ + "static/media/baseimage.4430f2f9.png";